/* eslint-disable no-magic-numbers */
/* eslint-disable complexity */
import { Theme, makeStyles } from '@futrli/ui-components';
import { STROKE_BORDER_POSITIONS, TableStyle } from '../../types';
import { addOpacityToColor } from '../../utils-colors';
import { varianceBG } from '../../constants';

interface Props {
  style: TableStyle;
}
export const useTableStyles = makeStyles<Theme, Props>(() => {
  return {
    // header row
    row: {
      fontSize: ({ style }: Props) => style.fontSize,
      fontWeight: ({ style }: Props) => style.fontWeight,
      color: ({ style }: Props) => style.color,
      background: ({ style }: Props) => addOpacityToColor(style.fill || 'transparent'),
      borderTop: ({ style }: Props) =>
        [STROKE_BORDER_POSITIONS.ALL_ROUND, STROKE_BORDER_POSITIONS.TOP, STROKE_BORDER_POSITIONS.TOP_BOTTOM].includes(
          style.strokePosition as STROKE_BORDER_POSITIONS
        )
          ? `${style.strokeWidth || 1}px solid ${style.strokeColor || '#000'}`
          : 'none',
      borderRight: ({ style }: Props) =>
        [STROKE_BORDER_POSITIONS.ALL_ROUND, STROKE_BORDER_POSITIONS.RIGHT].includes(
          style.strokePosition as STROKE_BORDER_POSITIONS
        )
          ? `${style.strokeWidth || 1}px solid ${style.strokeColor || '#000'}`
          : 'none',
      borderBottom: ({ style }: Props) =>
        [
          STROKE_BORDER_POSITIONS.ALL_ROUND,
          STROKE_BORDER_POSITIONS.BOTTOM,
          STROKE_BORDER_POSITIONS.TOP_BOTTOM
        ].includes(style.strokePosition as STROKE_BORDER_POSITIONS)
          ? `${style.strokeWidth || 1}px solid ${style.strokeColor || '#000'}`
          : 'none',
      borderLeft: ({ style }: Props) =>
        [STROKE_BORDER_POSITIONS.ALL_ROUND, STROKE_BORDER_POSITIONS.LEFT].includes(
          style.strokePosition as STROKE_BORDER_POSITIONS
        )
          ? `${style.strokeWidth || 1}px solid ${style.strokeColor || '#000'}`
          : 'none'
    },
    rowPast: {
      background: ({ style }: Props) => addOpacityToColor(style.fillPast || style.fill || 'transparent')
    },
    rowFuture: {
      background: ({ style }: Props) => addOpacityToColor(style.fillFuture || style.fill || 'transparent')
    },
    rowVariance: {
      background: ({ style }: Props) =>
        addOpacityToColor(style.fillVariance || varianceBG, style.fillVariance ? 0.2 : 1)
    },
    headerEmptyCell: {
      borderBottom: ({ style }: Props) =>
        [
          STROKE_BORDER_POSITIONS.ALL_ROUND,
          STROKE_BORDER_POSITIONS.BOTTOM,
          STROKE_BORDER_POSITIONS.TOP_BOTTOM
        ].includes(style.strokePosition as STROKE_BORDER_POSITIONS)
          ? `${style.strokeWidth || 1}px solid ${style.strokeColor || '#000'}`
          : 'none'
    },
    rowEven: {
      background: ({ style }: Props) => addOpacityToColor(style.fillEven || style.fill || 'transparent')
    },
    rowPastEven: {
      background: ({ style }: Props) =>
        addOpacityToColor(style.fillPastEven || style.fillPast || style.fillEven || style.fill || 'transparent')
    },
    rowFutureEven: {
      background: ({ style }: Props) =>
        addOpacityToColor(style.fillFutureEven || style.fillFuture || style.fillEven || style.fill || 'transparent')
    },
    rowVarianceEven: {
      background: ({ style }: Props) =>
        addOpacityToColor(
          style.fillVarianceEven || style.fillVariance || varianceBG,
          style.fillVarianceEven || style.fillVariance ? 0.2 : 1
        )
    },
    svgStyle: {
      'height': ({ style }: Props) => `${style.fontSize || 10}px !important`,
      '&::before': {
        fontSize: ({ style }: Props) => `${style.fontSize || 10}px !important`,
        lineHeight: '1 !important'
      }
    }
  };
});
